<template>
  <div class="donation">
    <PageBanner />
    <Breadcrumbs />

    <section class="content">
      <div class="container">
        <div class="row">
          <div class="col-lg-6"><iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d922.9446818852526!2d114.14615472921945!3d22.286370240007464!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3404007f1e893819%3A0x21919077950ea79e!2sHua+Fu+Commercial+Bldg%2C+101-113+Queen's+Rd+W%2C+Sheung+Wan!5e0!3m2!1sen!2shk!4v1444705856071"
              frameborder="0"
              allowfullscreen=""
              class="map-iframe"
            ></iframe></div>
          <div class="col">
            <h2 class="h4">辦事處</h2>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">地址：香港皇后大道西111號華富商業中心7樓702室</li>
              <li class="list-group-item">電話：(+852) 3722 1284</li>
              <li class="list-group-item">電郵：<a href="mailto:info@oef.org.hk">info@oef.org.hk</a></li>
              <li class="list-group-item">服務時間：星期一至五,早上九時至下午一時,及下午二時至六時</li>
              <li class="list-group-item">星期六,星期日及公眾假期休息</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import PageBanner from "@/components/pageBanner.vue";
  import Breadcrumbs from "@/components/breadcrumbs.vue";
  export default {
    name: "Donation",
    components: {
      PageBanner,
      Breadcrumbs
    }
  };
</script>